<template>
  <button type="button" class="quiz__back" @click="backToStep" >
    <span class="btn-back"></span>
    {{ text }}
  </button>
</template>

<script>
export default {
  name: "BtnBack",
  props: ['text'],
  methods:{
    backToStep(){
        this.$emit('backToStep');
    }
  }
}
</script>

<style scoped>
  .btn-back{
    width: 8px;
    height: 20px;
    margin-right: 16px;
    background: #fff url('../assets/img/angle-left.svg') no-repeat center center;
  }
  button{
    cursor: pointer;
  }
</style>